var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rrd-page d-flex"},[_c('PublicLeftSide'),_c('main',{staticClass:"rrd-content flex-fill d-flex flex-column p-0"},[_c('page-transition',[_c('div',{class:{'right-scroll': this.$router.currentRoute.name !== _vm.routeName.RN_LOGIN}},[_c('router-view')],1)]),_c('AppPublicFooter')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }